import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Globe } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

const languages = [
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
];

export default function LanguageSwitcher({ variant = 'default' }) {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    
    // Update URL path to reflect language
    const pathParts = location.pathname.split('/');
    const currentLang = pathParts[1];
    
    // Map of route translations
    const routeMap = {
      pt: {
        'about': 'sobre',
        'contact': 'contato',
        'privacy-policy': 'politica-de-privacidade',
        'terms-of-use': 'termos-de-uso',
        'guides': 'guias',
      },
      en: {
        'sobre': 'about',
        'contato': 'contact',
        'politica-de-privacidade': 'privacy-policy',
        'termos-de-uso': 'terms-of-use',
        'guias': 'guides',
      }
    };

    if (currentLang === 'pt' || currentLang === 'en') {
      // We're on a language-prefixed route
      pathParts[1] = lng;
      
      // Translate the route segment if it exists
      if (pathParts[2] && routeMap[lng]) {
        const translatedRoute = routeMap[lng][pathParts[2]];
        if (translatedRoute) {
          pathParts[2] = translatedRoute;
        }
      }
      
      navigate(pathParts.join('/'));
    }
  };

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

  if (variant === 'minimal') {
    return (
      <button
        onClick={() => changeLanguage(i18n.language === 'pt' ? 'en' : 'pt')}
        className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-sm"
      >
        <Globe className="w-4 h-4" />
        <span>{currentLang.flag} {currentLang.code.toUpperCase()}</span>
      </button>
    );
  }

  return (
    <Select value={i18n.language} onValueChange={changeLanguage}>
      <SelectTrigger className="w-[140px] bg-white/10 border-white/20 text-white">
        <Globe className="w-4 h-4 mr-2" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
